export const RATING_STATUS = Object.freeze({
  NONE: "NONE",
  LIKED: "LIKED",
  DISLIKED: "DISLIKED",
});

export const ARTICLE_NEWS = Object.freeze({
  ARTICLE: "article",
  NEWS: "news",
});
